import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetVehicleInformationSchema } from '../schemas/fleet-device-settings.schema';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Gets the device information
 * @returns Company Device Information
 */
export function postCompanyDevicesInformation(
  this: unknown,
  deviceIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyDevicesInformationUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({ deviceIds }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(fleetVehicleInformationSchema),
        error: z
          .object({
            detail: z.string(),
            errorCode: z.number(),
            message: z.string(),
          })
          .optional(),
        message: z.string().nullable(),
      })
    )
  );
}
